import React from 'react';
import PropTypes from 'prop-types';
import { Row as StyledRow } from 'styled-bootstrap-grid';

const Row = ({
  children, justifyContent, alignItems, className,
}) => (
  <StyledRow justifyContent={justifyContent} alignItems={alignItems} className={className}>
    {children}
  </StyledRow>
);

Row.propTypes = {
  children: PropTypes.node,
  justifyContent: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around']),
  alignItems: PropTypes.oneOf(['start', 'end', 'center', 'baseline ', 'stretch']),
  className: PropTypes.string,
};

Row.defaultProps = {
  children: null,
  justifyContent: null,
  alignItems: null,
  className: null,
};

export default Row;
